import React, { useState, useEffect } from 'react';
import { Box, Button, Grid, CircularProgress } from '@mui/material';
// import { PhotoCamera } from '@mui/icons-material';
import FormInput from '../inputs/FormInput';
import { useTranslation } from 'react-i18next';

const FormEditProfile = ({ profile, onSave, isSaving }) => {
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || 'en').startsWith('ar');

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        avatar: null,
    });
    // const [preview, setPreview] = useState(null);

    useEffect(() => {
        if (profile) {
            setFormData({
                name: profile.name || '',
                email: profile.email || '',
                avatar: null,
            });
            // setPreview(profile.avatar_url || null);
        }
    }, [profile]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    // const handleFileChange = (e) => {
    //     const file = e.target.files[0];
    //     if (file) {
    //         setFormData(prev => ({ ...prev, avatar: file }));
    //         setPreview(URL.createObjectURL(file));
    //     }
    // };

    const handleSubmit = (e) => {
        e.preventDefault();
        // const data = new FormData();
        const data = {};
        data.name = formData.name;
        data.email = formData.email;
        // if (formData.avatar) {
        //     data.append('avatar', formData.avatar);
        // }
        onSave(data);
    };

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
            {/* <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 4 }}>
                <Box sx={{ position: 'relative' }}>
                    <Avatar
                        src={preview}
                        sx={{ width: 120, height: 120, border: '4px solid white', boxShadow: 3 }}
                    />
                    <IconButton
                        color="primary"
                        component="label"
                        sx={{
                            position: 'absolute',
                            bottom: 0,
                            right: 0,
                            backgroundColor: 'white',
                            '&:hover': { backgroundColor: '#f5f5f5' }
                        }}
                    >
                        <input hidden accept="image/*" type="file" onChange={handleFileChange} />
                        <PhotoCamera />
                    </IconButton>
                </Box>
                <Typography variant="caption" sx={{ mt: 1, color: 'text.secondary' }}>
                    {isArabic ? 'انقر لتغيير الصورة' : 'Click to change photo'}
                </Typography>
            </Box> */}

            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <FormInput
                        label={isArabic ? 'الاسم بالكامل' : 'Full Name'}
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormInput
                        label={isArabic ? 'البريد الإلكتروني' : 'Email Address'}
                        name="email"
                        type="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        type="submit"
                        variant="contained"
                        disabled={isSaving}
                        sx={{ px: 4, py: 1, borderRadius: 2 }}
                    >
                        {isSaving ? <CircularProgress size={24} color="inherit" /> : (isArabic ? 'حفظ التغييرات' : 'Save Changes')}
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};

export default FormEditProfile;
